import styled, { css } from 'styled-components/macro';
import { Dialog } from 'components/ui/dialog';

export const StyledPanel = styled(Dialog.Panel)`
  ${({ theme }) => css`
    position: relative;
    width: 1200px;
    max-width: 80dvw;
    height: 675px;
    border-radius: 0;
    background-color: ${theme.colors.gray[100]};
  `}
`;

export const StickyContainer = styled.div`
  ${({ theme }) => css`
    position: sticky;
    bottom: ${theme.spacings.base};
    z-index: 10;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.spacings.base};
    width: 1200px;
    max-width: 80dvw;
  `}
`;

export const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const StyledThumbnail = styled.div<{
  $selected: boolean;
}>`
  ${({ theme, $selected }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background-color: ${theme.colors.gray[400]};
    outline: 2px solid transparent;
    border-radius: ${theme.radiuses.xs};
    overflow: hidden;
    transition-duration: ${theme.tokens.animation.duration.base};
    cursor: pointer;

    ${$selected &&
    css`
      outline: 2px solid ${theme.colors.primary[600]};
    `}

    img {
      transform: scale(1.1);
    }
  `}
`;

export const StyledZoomContainer = styled.div.attrs({
  className: 'swiper-zoom-container',
})`
  position: relative;
  height: 100%;
`;

export const ImageOrVideoWrapper = styled.div`
  ${({ theme }) => css`
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-color: ${theme.colors.gray[50]};

    img,
    video {
      position: relative;
      width: 100%;
      height: 100%;
    }
  `}
`;

export const ImageBackground = styled.div<{ $fileUrl?: string }>`
  ${({ $fileUrl }) => css`
    position: absolute;
    inset: 0;
    background-image: url(${$fileUrl});
    background-size: cover;
    background-position: center;
    filter: blur(16px);
    transform: scale(1.1);
  `}
`;

export const ArrowWrapper = styled.button`
  ${({ theme }) => css`
    padding: 0;
    position: absolute;
    z-index: 10;
    top: 50%;
    color: #ffffff;
    outline: none;
    border: none;
    background: none;
    transition-duration: ${theme.tokens.animation.duration.base};
    cursor: pointer;

    &.left {
      left: -8px;
      transform: translate(-100%, -50%);
    }
    &.right {
      right: -8px;
      transform: translate(100%, -50%);
    }

    &:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }
  `}
`;

export const LoaderWrapper = styled.div`
  position: absolute;
  z-index: 10;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ErrorWrapper = styled(LoaderWrapper)`
  ${({ theme }) => css`
    color: ${theme.colors.red[500]};
  `};
`;
